export * from "./location.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/location/index.ts